import React, { Component } from 'react';
import TransitionLink from 'components/transition-link/transition-link';
import Hero from 'components/heroes/hero';
import ResetPasswordSuccess from 'client/modal/reset-password-success';
import Page from 'components/page/page';
import MakeHash from 'make-hash';
import { Link } from 'react-router-dom';
import { gigyaPasswordReset } from './gigya.js';
import { loadScriptAsync } from './gigya';
import Endpoints from 'helpers/enums/endpoints';
import { validatePassword } from 'utils/password';
import classNames from 'classnames';
import Text from 'components/text/text';
export default class ResetPassword extends Component {
    constructor(props) {
        super(props);

        const { intl } = props;

        this.state = {
            serverError: false,
            serverMessages: [],
            loaderActive: false,
            email: null,
            token: null,
            password: '',
            confirmPassword: '',
            passwordError: '',
            confirmPasswordError: '',
            submitEnabled: false,
            formMessages: [],
        };

        this.page = {
            heading: 'Reset Password',
            intro:
                'Please enter a new password to use with your Ret\u00FCl Passport account.',
        };

        this.primaryAction = {
            label: 'Submit',
        };

        this.secondaryAction = {
            path: '/',
            label: 'Cancel',
        };

        this.fields = [];

        this.setUpHandlers();
    }

    /**
     * Binds any handlers to the correct context
     *
     * @method  setUpHandlers
     */
    setUpHandlers() {
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleError = this.handleError.bind(this);
        this.checkPasswordComplexity = this.checkPasswordComplexity.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.updateConfirmPassword = this.updateConfirmPassword.bind(this);
    }

    /**
     * React Lifecycle Hook
     * Invoked once, immediately after the initial rendering occurs.
     *
     * @method  componentDidMount
     */
    componentDidMount() {
        this.fields = [this.password, this.confirmPassword];

        // Load gigya screen set if gigya env configured
        if (process.env.REACT_APP_AUTH_BACKEND === 'gigya') {
            loadScriptAsync(
                `https://cdns.gigya.com/js/gigya.js?apikey=${process.env.REACT_APP_GIGYA_KEY}`
            ).then(() => {
                gigyaPasswordReset();
            });
        } else {
            const params = new URLSearchParams(window.location.search);
            const email = params.get('email');
            const token = params.get('token');

            const errorMessages = [];
            if (!email) errorMessages.push('Email is missing');
            if (!token) errorMessages.push('Token is missing');

            if (errorMessages.length > 0) {
                this.setState({
                    loading: false,
                    serverError: true,
                    formMessages: [
                        ...errorMessages,
                        <Link to="/reset/">
                            Please request a new password reset
                        </Link>,
                    ],
                });
            } else {
                this.setState({
                    email: params.get('email'),
                    token: params.get('token'),
                });
            }
        }
    }

    /**
     * Handles submission of login form
     * Will validate email and password fields
     * based on their latest values
     *
     * @method  handleSubmit
     */
    handleSubmit(event) {
        event.preventDefault();

        this.props.apiService
            .post(
                Endpoints.confirmPasswordReset,
                {
                    client: 'rider',
                    email: this.state.email,
                    token: this.state.token,
                    password: this.state.password,
                },
                this.handleError
            )
            .then((data) => {
                setTimeout(() => {
                    this.props.history.replace('/sign-in');
                }, 2000);

                if (typeof data === 'undefined') return;
            });
    }

    handleError(error) {
        try {
            error.response.json().then((resp) => {
                this.setState({
                    loading: false,
                    serverError: true,
                    formMessages: [resp.reason],
                });
            });
        } catch (e) {
            this.setState({
                loading: false,
                serverError: true,
                formMessages: ['something went wrong'],
            });
        }
    }

    formHasErrors() {
        let errors = this.fields.filter((field) => {
            const hasError =
                field.state.isError || field.input.value.trim().length === 0;

            if (hasError) {
                field.setState({ isError: true });
            }

            return hasError;
        });

        return errors.length > 0;
    }

    /**
     * Saves new password to user account
     *
     * @method  save
     */
    save() {
        let dialogView = (
            <ResetPasswordSuccess close={this.props.toggleDialog} />
        );
        this.props.toggleDialog(dialogView, false);
    }

    _renderHero() {
        return (
            <Hero title={this.page.heading} supportingTxt={this.page.intro} />
        );
    }

    updatePassword(event) {
        // Check that confirm password matches only when it has had entry
        event.persist();
        this.setState({ password: event.target.value }, () => {
            if (this.state.password.length > 0) {
                this.checkPasswordComplexity(event);
            }
        });
    }

    updateConfirmPassword(event) {
        // Check that the confirm password matches
        const confirmPassword = event.target.value;
        event.persist();
        this.setState({ confirmPassword }, () => {
            this.checkPasswordComplexity(event);
        });
    }

    checkPasswordComplexity(event) {
        if (!validatePassword(this.state.password)) {
            this.setState({
                passwordError:
                    'Passwords must be at least 8 characters long, include upper- and lower-case letters, and include a number',
            });
        } else {
            this.setState({ passwordError: '' });
        }

        if (this.state.confirmPassword !== this.state.password) {
            this.setState({ confirmPasswordError: 'Passwords must match' });
        } else {
            this.setState({ confirmPasswordError: '' });
        }
    }

    checkPasswordsMatch(event) {
        if (this.state.password !== this.state.confirmPassword) {
            this.setState({
                confirmPasswordError: 'Passwords must match',
            });
        }
    }

    _renderFormMessages() {
        const ulClasses = classNames('form-messages', {
            'form-messages_hasMessage': this.state.formMessages.length > 0,
        });
        const color = this.state.serverError ? 'DefaultOrange' : 'DefaultBlue';

        return (
            <ul className={ulClasses}>
                {this.state.formMessages.map((msg, i) => {
                    if (typeof msg == 'string') {
                        return (
                            <li key={MakeHash(`${msg}-${i}`)}>
                                <Text color={color} weight="light">
                                    {msg.endsWith('.') ? msg : msg + '.'}
                                </Text>
                            </li>
                        );
                    } else {
                        return <li key={MakeHash(`${i}`)}>{msg}</li>;
                    }
                })}
            </ul>
        );
    }

    render() {
        const pageHero = this._renderHero();

        const passwordFieldClass = classNames('field field_floatingLabel', {
            field_hasError: this.state.passwordError,
        });

        const confirmPasswordFieldClass = classNames(
            'field field_floatingLabel',
            { field_hasError: this.state.confirmPasswordError }
        );

        const submitEnabled =
            this.state.passwordError.length === 0 &&
            this.state.confirmPasswordError.length === 0 &&
            this.state.password.length > 0;

        const formMessages = this._renderFormMessages();

        // TODO: remove userScreensDiv along with gigya when the switch happens
        // div id="userScreensDiv" is where gigya screensets are appended
        const className =
            process.env.REACT_APP_AUTH_BACKEND === 'gigya' ? 'hidden' : '';

        return (
            <Page title={this.page.heading} pageHero={pageHero}>
                <div className="container container_constrainedMd">
                    <div className="gigya-screen-set" id="userScreensDiv" />
                    <form
                        onSubmit={this.handleSubmit}
                        autoComplete="off"
                        id="reset-password-stuff"
                        noValidate
                        className={className}
                        disabled={this.submitEnabled}
                    >
                        {formMessages}
                        <div>
                            <div className="set-hd">
                                <div className={passwordFieldClass}>
                                    <label
                                        className="field-label"
                                        htmlFor="password"
                                    >
                                        New Password
                                    </label>
                                    <input
                                        id="password"
                                        name="password"
                                        type="password"
                                        label="New Password"
                                        onChange={this.updatePassword}
                                        value={this.state.password}
                                        onBlur={this.checkPasswordComplexity}
                                        className="field-input"
                                    />
                                    <span
                                        className={
                                            passwordFieldClass && 'field-error'
                                        }
                                    >
                                        {this.state.passwordError}
                                    </span>
                                </div>
                            </div>

                            <div className="set-bd set-bd_super">
                                <div className={confirmPasswordFieldClass}>
                                    <label
                                        className="field-label"
                                        htmlFor="confirm-password"
                                    >
                                        Confirm New Password
                                    </label>
                                    <input
                                        id="confirm-password"
                                        name="confirm-password"
                                        type="password"
                                        label="New Password"
                                        onChange={this.updateConfirmPassword}
                                        value={this.state.confirmPassword}
                                        onBlur={this.checkPasswordComplexity}
                                        className="field-input"
                                    />
                                    <span
                                        className={
                                            confirmPasswordFieldClass &&
                                            'field-error'
                                        }
                                    >
                                        {this.state.confirmPasswordError}
                                    </span>
                                </div>
                            </div>

                            <div className="set-bd set-bd_super">
                                <div className="set mix-set_alignCenter">
                                    <div className="set-hd">
                                        <button
                                            disabled={!submitEnabled}
                                            className="btn btn_fixedWidth"
                                            type="submit"
                                        >
                                            {this.primaryAction.label}
                                        </button>
                                    </div>
                                    <div className="set-bd set-bd_separated">
                                        <TransitionLink
                                            className="txt txt_reg mix-txt_colorDefaultBlue"
                                            to={this.secondaryAction.path}
                                        >
                                            {this.secondaryAction.label}
                                        </TransitionLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </Page>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/pages/auth/reset-password.jsx